import { FEE_KLIKOO } from "../../../constants/admin/masterdata/constants";

const initialState = {
  loadingGetFeeKlikoo: true,
  loadingPostFeeKlikoo: false,
  dataFeeKlikoo: [],
};

export const feeKlikooReducer = (state = initialState, action) => {
  switch (action.type) {
    case FEE_KLIKOO.GET_DATA_FEE_KLIKOO_SUCCESS:
      return {
        ...state,
        dataFeeKlikoo: action.data,
      };
    case FEE_KLIKOO.LOADING_DATA_FEE_KLIKOO_SUCCESS:
      return {
        ...state,
        loadingGetFeeKlikoo: action.load,
      };
    case FEE_KLIKOO.LOADING_POST_FEE_KLIKOO_SUCCESS:
      return {
        ...state,
        loadingPostFeeKlikoo: action.load,
      };
    default:
      return state;
  }
};
